import api from "shared/api";
import { CredentialContainer } from "./models";

const prefix = "api/credentials";

export const getAll = async (): Promise<CredentialContainer> => {
  try {
    const res = await api().get<CredentialContainer>(`${prefix}/all`);
    return res.data;
  } catch (e) {
    throw e;
  }
};
